/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StageListIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC0klEQVR4nMVVSWtUQRCegMQFNFHjchA3UMS/oDBHx8yrrpqBnqpJ1AkGEUHxKAiixojjzV+iBjc0R28iGq+JosYYQTy4xgVCpPrVG19myyCIDQ9eb/VVfV9VdSbzP4f3fh1i+TgQjzmS147kGyD/csgvbO2Y977nbwyvBOQLjvirI1lo9wHKR0dy3nvf3ZHxfHFgJxA/rRlBuQ/IQ0S8O5vNLtNP/x3JUSAZrwERP+kvDmxrazyK/FYgmY4N8yQUS/uWciii8n5HMmV3XiHy9qYHc7ncckf8zA4+dM6t1vV+7zcDyqhDmXDI3wFlLvyTjBQKhzbGdwfXhDtxJI/VVgOAXrBwp/SCrgFJyThuoQF/0jMpkMlYFz63yDhipRdIPodNoyU2zvOxVzIeER8kOrw+nx9Y6wqSV23M2LwrsE/RFYDVZg0AiE8YNQ8SWvSQeTqSyWS6mrDalUStUQLIJnMsCA/Iw2mAMVscMrouG+A9NaQp6IivAvIsEL91JFVLyy51yu5eCraQhy2KGykAeamL+WJ5VwwQi41YOmCA1SYaVMOe0hWn80SgqVjeY1E9/wOA8lMXE/VDppAsRFG5z7yabQBAead7QZPY4FwAiKJVNv+SBggGs5XKivQ8EcpoqY9gJmknBvg+DaAapikKxaUVmqYICpJrRRGgXGlaUAGk3KcdoUFk50pHLIJRK5qT5mW3gmgkdSJ3NrRjJn1H55rvgHxW+W13zwSeaYyO32jdpAAqvUnnrO8/ubiFnHYojxzJD0D+kNSFGjLHbhmNVUC+bcU5vcgbLW/j9lqyVigMbrG+s8jDWgQ2T1qL0dlTfy4MzSBAueic39vQ/Kg9ABDfAeQz+jmUu00B6gegnGrV5OoBmlG0JIBDudkpQEcU1Q/EMrR6MnPebzDdgsjNKGoQudlQb+zRv669JTz4mkngd+i+pmLtBUynKcl0UqT/fPwGuA4xCqgJviwAAAAASUVORK5CYII=)
 */
export const StageListIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.24 13.2c.33.1.71-.1.73-.44A11 11 0 1 0 2.91 18.2c.34.5 1.05.51 1.46.07l.02-.02c.33-.36.34-.91.07-1.33a9 9 0 1 1 16.49-3.98c0 .03.02.06.05.06a4 4 0 0 1 1.24.2Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.59 16.03c.28.03.46.3.43.59L13 17v4a4 4 0 0 0 .2 1.24c.1.33-.1.71-.44.73a11.17 11.17 0 0 1-5.62-1.1 1.52 1.52 0 0 1-.8-1.84 6 6 0 0 1 6.25-4ZM18.98 12.57a.48.48 0 0 1-.48.43H17a.08.08 0 0 1-.08-.1 5 5 0 1 0-9.53 1.04c.18.42.14.9-.17 1.23l-.05.06c-.43.47-1.18.42-1.45-.14a7 7 0 1 1 13.26-2.52Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M17 15a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4Zm1 1.5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm0 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
